export default "__VITE_ASSET__BR1gQMYP__"